document.addEventListener('DOMContentLoaded', function() {
    // Seleccionar todos los enlaces del grid
    const gridLinks = document.querySelectorAll('.grid-link__content-link');
    const sections = document.querySelectorAll('main .shopify-section');

    // Buscar la sección grid-link
    const gridLinkSection = document.querySelector('main .grid-link');
    if (gridLinkSection) {
        // Obtener todas las secciones después de grid-link
        const allSections = Array.from(sections);
        const gridLinkIndex = allSections.indexOf(gridLinkSection.closest('.shopify-section'));
        
        // Asignar índices solo a las secciones después de grid-link (excluyendo grid-link)
        allSections.slice(gridLinkIndex + 1).forEach((section, index) => {
            section.setAttribute('data-press-index', index + 1);
        });
    }
    
    gridLinks.forEach((link, i) => {
        link.addEventListener('click', function(e) {
            // No ejecutar si es el enlace del RVO Help Center
            if (this.classList.contains('open-contact')) {
                return;
            }
            
            e.preventDefault();

            sections[i].setAttribute('data-target-section', i + 1);
            
            // Obtener el índice de la sección de prensa
            const targetSection = this.getAttribute('data-target-section');
            if (!targetSection) return;
            
            // Encontrar la sección de prensa correspondiente
            const pressSection = document.querySelector(`[data-press-index="${targetSection}"]`);
            if (pressSection) {
                // Remover temporalmente la clase AOS y el atributo data-aos
                const aosAnimation = pressSection.getAttribute('data-aos');
                pressSection.removeAttribute('data-aos');
                pressSection.classList.remove('aos-init', 'aos-animate');
                
                // Calcular la posición de desplazamiento
                const offset = pressSection.getBoundingClientRect().top + window.pageYOffset - 100;
                
                // Desplazamiento suave
                window.scrollTo({
                    top: offset,
                    behavior: 'smooth'
                });
                
                // Restaurar la animación AOS después de un breve retraso
                setTimeout(() => {
                    pressSection.setAttribute('data-aos', aosAnimation);
                    AOS.refresh();
                }, 1000);
            }
        });
    });
});
